var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5702 6.33786C14.3315 6.33786 14.1405 6.51648 14.1405 6.73975V10.3955C14.1405 11.3898 13.2746 12.1965 12.2146 12.1965H2.78544C1.7222 12.1965 0.859508 11.3868 0.859508 10.3955V6.68021C0.859508 6.45694 0.668506 6.27832 0.429754 6.27832C0.191002 6.27832 0 6.45694 0 6.68021V10.3955C0 11.8333 1.25106 13.0003 2.78544 13.0003H12.2146C13.7521 13.0003 15 11.8304 15 10.3955V6.73975C15 6.51945 14.809 6.33786 14.5702 6.33786Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19747 9.80909C7.28024 9.88649 7.39166 9.92817 7.49989 9.92817C7.60813 9.92817 7.71954 9.88946 7.80231 9.80909L10.5336 7.25485C10.7024 7.09708 10.7024 6.84403 10.5336 6.68625C10.3649 6.52848 10.0943 6.52848 9.92561 6.68625L7.92965 8.55579V0.40189C7.92965 0.178618 7.73864 0 7.49989 0C7.26114 0 7.07014 0.178618 7.07014 0.40189V8.55579L5.07099 6.68625C4.90227 6.52848 4.63168 6.52848 4.46296 6.68625C4.29425 6.84403 4.29425 7.09708 4.46296 7.25485L7.19747 9.80909Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.ba7fa140f3d0c82906bbeb88c5014c23.svg";
export { ForwardRef as ReactComponent };